import { combineReducers } from 'redux';
import productsReducer from './products/reducer';
import associationsReducer from './associations/reducer';
import formReducer from './form/reducer';
import modalsReducer from './modals/reducer';
import importReducer from './importer/reducer';
import validationReducer from './validation/reducer';
import loaderReducer from './loader/reducer';

const rootReducer = combineReducers({
  form: formReducer,
  products: productsReducer,
  associations: associationsReducer,
  modals: modalsReducer,
  import: importReducer,
  validation: validationReducer,
  loader: loaderReducer,
});

export default rootReducer;
